// extracted by mini-css-extract-plugin
module.exports = {"col":"col--dIwNd"};